const tr = {
    packageBilling:{
      attributes:{
        user_id:            'Usuário ID',
        package_id:         'Adicional ID',
        transaction_at:     'Data da Transação',
        expires_at:         'Data Renovação',
        price:              'Preço',
        product_id:         'Produto',
        transaction_id:     'ID Transação',
        store:              'Loja',
        state:              'Status',
        user_name:          'Usuário',
        pack_name:          'Adicional',
        pack_type:          'Tipo Adicional',
        period:             'Período de Assinatura',
        origin:             'Nova/Renovação',
        pack_size:          'Licenças',
        partner_status:     'Status do Parceiro',
        partner:            'Parceiro',
        resources_size:     'Quantidade de Licenças',
        check_status:       'Verificar Status',
      },
      extras:{
        transactions: 'Transações',
        transaction_data: 'Dados da Transação',
        loading: 'Carregando...',
        active_store: 'Ativo na loja',
        state_store: 'Status da loja',
        validity_store: 'Validade da loja',
        show_billing: 'Visualizando compra',
      },
      defSingular: 'Dados da Compra',
      defPlural: 'Compras de Adicionais',
    }
  };
  
  export default tr;
  